(function () {
  'use strict';

  console.log('[PosterMap] Script loaded');

  function start() {
    document.querySelectorAll('.poster-map-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  function initSection(sectionEl) {
    if (sectionEl.dataset.posterMapInitialized === 'true') return;

    var sectionId = sectionEl.id.replace('poster-map-section-', '');
    var config = window['posterMapConfig_' + sectionId];

    if (!config || !config.csvUrl) {
      console.error('[PosterMap] Missing map configuration or CSV URL.');
      return;
    }

    if (typeof L === 'undefined' ||
        typeof L.markerClusterGroup !== 'function') {
      console.error('[PosterMap] Leaflet or MarkerCluster failed to load.');
      return;
    }

    var mapContainer = document.getElementById('poster-map-' + sectionId);
    if (!mapContainer) return;

    try {
      var state = setupMap(sectionId, config, sectionEl);
      sectionEl.dataset.posterMapInitialized = 'true';

      fetch(config.csvUrl)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('CSV request failed: ' + response.status);
          }
          return response.text();
        })
        .then(function (csvText) {
          var posters = parsePosterCsv(csvText);

          if (!posters.length) {
            console.error(
              '[PosterMap] No valid posters loaded. Check the CSV columns.'
            );
            return;
          }

          // Store the same CSV data for the gallery.
          state.posters = posters;

          posters.forEach(function (poster) {
            addMarker(state, poster);
          });

          console.log('[PosterMap] Loaded posters:', posters.length);

          console.log(
            '[PosterMap] Category totals:',
            posters.reduce(function (totals, poster) {
              totals[poster.category] =
                (totals[poster.category] || 0) + 1;
              return totals;
            }, {})
          );

          setupTabs(sectionEl, state);

          // Connect gallery to the existing map.
          setupPosterGallery(state);
          updatePosterGallery(state);

          state.clusterGroup.refreshClusters();
        })
        .catch(function (error) {
          console.error('[PosterMap] Failed to load CSV:', error);
        });
    } catch (error) {
      console.error('[PosterMap] Map initialization failed:', error);
    }
  }

  /* CSV parser: supports quoted commas, escaped quotes and multiline cells. */
  function parseCsv(text) {
    text = String(text || '').replace(/^\uFEFF/, '');

    var rows = [];
    var row = [];
    var field = '';
    var quoted = false;

    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      var next = text[i + 1];

      if (quoted) {
        if (ch === '"' && next === '"') {
          field += '"';
          i++;
        } else if (ch === '"') {
          quoted = false;
        } else {
          field += ch;
        }
      } else if (ch === '"' && field.length === 0) {
        quoted = true;
      } else if (ch === ',') {
        row.push(field);
        field = '';
      } else if (ch === '\n') {
        row.push(field.replace(/\r$/, ''));
        rows.push(row);
        row = [];
        field = '';
      } else {
        field += ch;
      }
    }

    if (field.length || row.length) {
      row.push(field.replace(/\r$/, ''));
      rows.push(row);
    }

    return rows.filter(function (r) {
      return r.some(function (v) {
        return String(v).trim() !== '';
      });
    });
  }

  function parsePosterCsv(text) {
    var rows = parseCsv(text);
    if (!rows.length) return [];

    var headers = rows[0].map(function (header) {
      return String(header || '').trim().replace(/^\uFEFF/, '');
    });

    var idx = {
      title: headers.indexOf('Title'),
      location: headers.indexOf('Location'),
      handle: headers.indexOf('Handle'),
      url: headers.indexOf('Product URL'),
      image: headers.indexOf('Image Src'),
      lat: headers.indexOf('Latitude'),
      lng: headers.indexOf('Longitude'),
      category: headers.indexOf('Category')
    };

    if (
      idx.handle < 0 ||
      idx.lat < 0 ||
      idx.lng < 0 ||
      idx.category < 0
    ) {
      console.error('[PosterMap] Required CSV columns are missing.', headers);
      return [];
    }

    var posters = [];

    for (var i = 1; i < rows.length; i++) {
      var cols = rows[i];

      function get(index) {
        return index >= 0 && cols[index] != null
          ? String(cols[index]).trim()
          : '';
      }

      var handle = get(idx.handle);
      var lat = Number(get(idx.lat));
      var lng = Number(get(idx.lng));
      var category = normalizeCategory(get(idx.category));

      if (!handle || !Number.isFinite(lat) || !Number.isFinite(lng)) {
        continue;
      }

      if (!category) {
        console.warn(
          '[PosterMap] Skipping unknown category for:',
          handle,
          get(idx.category)
        );
        continue;
      }

      posters.push({
        title: get(idx.title),
        location: get(idx.location),
        handle: handle,
        url: get(idx.url) || ('/products/' + handle),
        image: get(idx.image),
        lat: lat,
        lng: lng,
        category: category
      });
    }

    return posters;
  }

  function normalizeCategory(value) {
    var category = String(value || '').trim().toLowerCase();

    if (category === 'alle') return 'Alle';

    if (category === 'drone' || category === 'drone-plakater') {
      return 'Drone';
    }

    if (
      category === 'undervands' ||
      category === 'undervands-plakater'
    ) {
      return 'Undervands';
    }

    if (category === 'analog' || category === 'analog-plakater') {
      return 'Analog';
    }

    return '';
  }

  function setupMap(sectionId, config, sectionEl) {
    var map = L.map('poster-map-' + sectionId, {
      zoomControl: false,
      scrollWheelZoom: false
    });

    // Preserve the existing Denmark-wide initial view.
    var denmarkBounds = L.latLngBounds(
      [54.55, 8.00],
      [57.80, 15.25]
    );

    map.fitBounds(denmarkBounds, {
      padding: [24, 24],
      maxZoom: 7,
      animate: false
    });

    L.control.zoom({ position: 'topright' }).addTo(map);

    var mapContainer = document.getElementById('poster-map-' + sectionId);
    var hint = sectionEl.querySelector('.poster-map-click-hint');

    mapContainer.addEventListener('click', function () {
      map.scrollWheelZoom.enable();
      if (hint) hint.style.display = 'none';
    });

    mapContainer.addEventListener('mouseleave', function () {
      map.scrollWheelZoom.disable();
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      subdomains: 'abc',
      maxZoom: 19
    }).addTo(map);

    var clusterGroup = L.markerClusterGroup({
      maxClusterRadius: 45,
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      chunkedLoading: true,

      iconCreateFunction: function (cluster) {
        var count = cluster.getChildCount();
        var size = count < 10 ? 30 : count < 50 ? 36 : count < 200 ? 42 : 48;

        return L.divIcon({
          html: '<div class="poster-cluster" style="width:' +
            size + 'px;height:' + size + 'px;">' +
            count + '</div>',
          className: 'poster-cluster-wrap',
          iconSize: [size, size]
        });
      }
    });

    map.addLayer(clusterGroup);

    // Preserve the existing map resize behavior.
    requestAnimationFrame(function () {
      map.invalidateSize({ pan: false });
      map.fitBounds(denmarkBounds, {
        padding: [24, 24],
        maxZoom: 7,
        animate: false
      });
    });

    return {
      map: map,
      clusterGroup: clusterGroup,
      sectionEl: sectionEl,
      allMarkers: [],
      posters: [],
      activeCategory: 'Alle',
      gallery: null
    };
  }

  function createPinIcon() {
    return L.divIcon({
      className: 'poster-pin',
      html:
        '<svg width="26" height="34" viewBox="0 0 26 34" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M13 0C5.8 0 0 5.8 0 13c0 9.75 13 21 13 21s13-11.25 13-21C26 5.8 20.2 0 13 0z" fill="#c9622a" stroke="#ffffff" stroke-width="1.5"/>' +
        '<circle cx="13" cy="13" r="5" fill="#ffffff"/>' +
        '</svg>',
      iconSize: [26, 34],
      iconAnchor: [13, 34],
      popupAnchor: [0, -30]
    });
  }

  function addMarker(state, poster) {
    var marker = L.marker([poster.lat, poster.lng], {
      icon: createPinIcon()
    });

    if (poster.location) {
      marker.bindTooltip(poster.location, {
        direction: 'top',
        offset: [0, -30],
        className: 'poster-tooltip'
      });
    }

    marker.on('click', function () {
      showPosterPopup(state.sectionEl, state.map, marker, poster);
    });

    state.clusterGroup.addLayer(marker);

    state.allMarkers.push({
      marker: marker,
      category: poster.category
    });
  }

  function setupTabs(sectionEl, state) {
    var tabs = sectionEl.querySelectorAll('.poster-map-tab');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var selected = normalizeCategory(tab.dataset.collection);

        if (tab.dataset.collection === 'Alle') {
          selected = 'Alle';
        }

        if (!selected) {
          console.warn('[PosterMap] Unknown tab:', tab.dataset.collection);
          return;
        }

        tabs.forEach(function (otherTab) {
          otherTab.classList.toggle('is-active', otherTab === tab);
        });

        var markersToShow = state.allMarkers
          .filter(function (item) {
            return selected === 'Alle' || item.category === selected;
          })
          .map(function (item) {
            return item.marker;
          });

        state.clusterGroup.clearLayers();
        state.clusterGroup.addLayers(markersToShow);

        // Keep the gallery in sync with the selected category.
        state.activeCategory = selected;
        updatePosterGallery(state);

        console.log(
          '[PosterMap] Showing ' + markersToShow.length +
          ' posters for ' + selected
        );
      });
    });
  }

  /* Connect the gallery to map movement and zoom. */
  function setupPosterGallery(state) {
    var gallery = state.sectionEl.querySelector('.poster-map-gallery');

    if (!gallery) {
      gallery = state.sectionEl.querySelector('[id^="poster-map-gallery-"]');
    }

    if (!gallery) {
      console.warn('[PosterMap] Gallery container not found.');
      return;
    }

    state.gallery = gallery;

    state.map.on('moveend zoomend', function () {
      updatePosterGallery(state);
    });
  }

  /* Show up to six posters inside the visible map area. */
  function updatePosterGallery(state) {
    // IMPORTANT: Poster suggestions are desktop-only.
    if (window.matchMedia('(max-width: 767px)').matches) return;

    if (!state.gallery || !state.posters) return;

    var gallery = state.gallery;
    var map = state.map;

    // At the initial Denmark-wide zoom, ask the visitor to zoom in.
    if (map.getZoom() < 8) {
      gallery.innerHTML =
        '<p class="poster-map-gallery__message">' +
        'Zoom ind på et område for at se plakater herfra.' +
        '</p>';
      return;
    }

    var bounds = map.getBounds();
    var center = map.getCenter();
    var category = state.activeCategory || 'Alle';

    var visiblePosters = state.posters.filter(function (poster) {
      return (
        bounds.contains([poster.lat, poster.lng]) &&
        (category === 'Alle' || poster.category === category) &&
        poster.image
      );
    });

    // Sort by proximity to the center of the visible map.
    visiblePosters.sort(function (a, b) {
      return distanceFromCenter(a, center) - distanceFromCenter(b, center);
    });

    visiblePosters = visiblePosters.slice(0, 6);

    if (!visiblePosters.length) {
      gallery.innerHTML =
        '<p class="poster-map-gallery__message">' +
        'Ingen plakater fundet i det viste område. Prøv at flytte kortet eller zoome lidt ud.' +
        '</p>';
      return;
    }

    var heading = document.createElement('h3');
    heading.className = 'poster-map-gallery__heading';
    heading.textContent = 'Plakater i det viste område';

    var grid = document.createElement('div');
    grid.className = 'poster-map-gallery__grid';

    visiblePosters.forEach(function (poster) {
      var link = document.createElement('a');
      link.className = 'poster-map-gallery__card';
      link.href = poster.url;
      link.setAttribute('aria-label', poster.title || 'Se plakat');

      var image = document.createElement('img');
      image.className = 'poster-map-gallery__image';
      image.src = poster.image;
      image.alt = poster.title || '';
      image.loading = 'lazy';

      var title = document.createElement('span');
      title.className = 'poster-map-gallery__title';
      title.textContent = poster.title || poster.location || 'Se plakat';

      link.appendChild(image);
      link.appendChild(title);
      grid.appendChild(link);
    });

    gallery.replaceChildren(heading, grid);
  }

  function distanceFromCenter(poster, center) {
    var latitudeDifference = poster.lat - center.lat;
    var longitudeDifference =
      (poster.lng - center.lng) *
      Math.cos(center.lat * Math.PI / 180);

    return (
      latitudeDifference * latitudeDifference +
      longitudeDifference * longitudeDifference
    );
  }

  function showPosterPopup(sectionEl, map, marker, poster) {
    var template = sectionEl.querySelector('.poster-map-popup-template');
    if (!template || !template.firstElementChild) return;

    var content = template.firstElementChild.cloneNode(true);
    var image = content.querySelector('.poster-popup__image');
    var title = content.querySelector('.poster-popup__title');
    var location = content.querySelector('.poster-popup__location');
    var price = content.querySelector('.poster-popup__price');
    var viewButton = content.querySelector('.poster-popup__view-product');
    var closeButton = content.querySelector('.poster-popup__close');

    image.src = poster.image || '';
    image.alt = poster.title;
    title.textContent = poster.title;
    location.textContent = poster.location || '';
    price.textContent = 'Indlæser pris…';
    viewButton.href = poster.url;

    var popup = L.popup({
      offset: [0, -8],
      closeButton: false,
      className: 'poster-leaflet-popup',
      maxWidth: 280
    })
      .setLatLng(marker.getLatLng())
      .setContent(content)
      .openOn(map);

    closeButton.addEventListener('click', function () {
      map.closePopup(popup);
    });

    fetch('/products/' + encodeURIComponent(poster.handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Product not found');
        return response.json();
      })
      .then(function (product) {
        if (!product.variants || !product.variants.length) {
          throw new Error('No product variants found');
        }

        var lowestPrice = Math.min.apply(
          null,
          product.variants.map(function (variant) {
            return Number(variant.price);
          })
        );

        price.textContent = 'Fra ' + formatMoney(lowestPrice);
      })
      .catch(function (error) {
        console.error(
          '[PosterMap] Could not load product price:',
          poster.handle,
          error
        );
        price.textContent = '';
      });
  }

  function formatMoney(amount) {
    var value = Number(amount);

    if (!Number.isFinite(value)) return '';

    // Shopify's product.js usually returns prices in currency units.
    if (value > 10000) value = value / 100;

    return value.toLocaleString('da-DK', {
      style: 'currency',
      currency: 'DKK'
    });
  }
})();